import { useIntl } from 'react-intl';
import { Style } from '@components/style';
import PropTypes from 'prop-types';
// PHISON customized !!!
function EmployeeInput({ employeeRef }) {
  const style = new Style();
  const intl = useIntl();

  return (
    <div
      className="d-flex justify-content-between"
      style={{ marginTop: '20px', height: '44px' }}
    >
      <input
        id="employeeId"
        style={{
          border: `1px solid ${style.getUiConfig().gray3Color}`,
          borderRadius: '10px',
          color: `${style.getUiConfig().blackColor}`,
          width: '43vw',
        }}
        ref={employeeRef}
        placeholder={intl.formatMessage({ id: 'phison.employee.input' })}
      />
      <input
        id="extensionNumber"
        type="number"
        style={{
          border: `1px solid ${style.getUiConfig().gray3Color}`,
          borderRadius: '10px',
          color: `${style.getUiConfig().blackColor}`,
          width: '34vw',
          minWidth: '10px',
        }}
        placeholder={intl.formatMessage({ id: 'phison.employee.extNumber' })}
      />
    </div>
  );
}

EmployeeInput.propTypes = {
  employeeRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    .isRequired,
};
export default EmployeeInput;
